<template>
    <layout :breadcrumbs="breadcrumbs">
        <template slot="header">
            <h1 class="text-center">
                Compare Trims
            </h1>
        </template>

        <div class="compare-boxes d-flex">
            <div
                v-for="trim in compareSelectedTrims"
                :key="trim.id"
                class="compare-box"
            >
                <div class="card-buttons">
                    <div class="inventory-available">
                        122 Available
                    </div>
                </div>
                <div class="vehicle-image">
                    <trim-image :trim="trim" />
                </div>
                <h1>
                    {{ trim.year }} {{ trim.make.name }} {{ trim.model.name }}
                </h1>
                <h2>{{ trim.trim }}</h2>
                <div class="vehicle-info">
                    <p>Engine: {{ trim.engineDisplacement }}</p>
                    <p>Transmission: {{ trim.transmissionDescription }}</p>
                    <p>{{ trim.drivetrain }}</p>
                </div>
                <div class="starting-at">
                    <div class="label">
                        Starting at
                    </div>
                    <div class="price">
                        {{ trim.startingMsrp | numeral("$0,0") }}
                    </div>
                </div>
                <div class="cta">
                    <a href="#">
                        Build &amp; Price
                    </a>
                </div>
                <div class="mpg-block">
                    <div class="label">
                        EPA Estimated MPG:
                    </div>
                    <div class="values">
                        <div class="mpg">
                            <div class="value">
                                {{ trim.cityMpg }}
                            </div>
                            <div class="label">
                                CITY
                            </div>
                        </div>
                        <div class="slash">
                            /
                        </div>
                        <div class="mpg">
                            <div class="value">
                                {{ trim.hwyMpg }}
                            </div>
                            <div class="label">
                                HWY
                            </div>
                        </div>
                        <div class="slash">
                            /
                        </div>
                        <div class="mpg">
                            <div class="value">
                                {{ trim.avgMpg }}
                            </div>
                            <div class="label">
                                AVG
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import _ from "lodash";
import { get } from "vuex-pathify";
import Layout from "../components/Layout";
import TrimImage from "Modules/ShopBy/Make/components/TrimImage";

export default {
    components: { TrimImage, Layout },
    props: {
        modelId: {
            type: String,
            required: true
        },
        makeName: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            breadcrumbs: [
                {
                    text: "Make & Model",
                    to: { name: "make-model" }
                },
                {
                    text: "Trim",
                    to: {
                        name: "trims",
                        params: {
                            modelId: this.modelId,
                            makeName: this.makeName
                        }
                    }
                },
                {
                    text: "Compare Trims",
                    active: true
                }
            ]
        };
    },

    computed: {
        compareSelectedTrims: get("shopBy/compareSelectedTrims")
    },

    mounted() {
        if (_.isEmpty(this.compareSelectedTrims)) {
            this.$router.push({
                name: "trims",
                params: { modelId: this.modelId, makeName: this.makeName }
            });
        }
    }
};
</script>
